<template>
<!--   <div> -->
     <v-dialog v-model="dialogshowimage" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card style="background-color: rgba(0, 0, 0, 0.9);">
          <v-toolbar dark style="background-color: #1b232d;">
             <v-flex xl1 lg1 md1 sm1 style="text-align: right; padding-right: 2vw;">
            <v-avatar class="user-photo" style="cursor: pointer;" @click="openPictureProfile(DetailImage.pic_pro, DetailImage.typeuser)" >
              <img v-if="DetailImage.pic_pro" :src="DetailImage.pic_pro" class="alligator-turtle">
              <img v-else-if="DetailImage.typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
              <img v-else-if="DetailImage.typeuser === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
            </v-avatar>
          </v-flex>
          <v-flex xl6 lg6 md6 sm6>
            <b style="font-size: 14px;"> {{DetailImage.file_name}} </b>
            <p style="font-size: 12px; margin-bottom: 0px;"> {{$t('Dialog.showImage.by')}} {{DetailImage.file_owner}} &nbsp;&nbsp;| &nbsp;{{date(DetailImage.timestamp)}}
              <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{time(DetailImage.timestamp)}}
            </p>
          </v-flex>
          <v-flex xl4 lg4 md4 sm4 style="text-align: right;">
            <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic(DetailImage.file_name)">
              <v-icon>file_download</v-icon>&nbsp; {{$t('AnswerQuestion.download')}}
            </v-btn>
            <v-btn depressed small class="btncancel CSChatThai" @click="sendonebox(DetailImage.tokenmessage)">
              <v-icon>cloud_upload</v-icon> &nbsp; {{$t('AnswerQuestion.sendOnebox')}}
            </v-btn>
          </v-flex>
         <v-flex xl1 lg1 md1 sm1 style="text-align: right;">
          <v-btn icon @click="closeDialogShowImage">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
          </v-flex>

          </v-toolbar>
          <div style="background: none;">
            <img class="modal-contentc" :src="DetailImage.path">
          </div>
        </v-card>
        <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
        <SaveOnebox :dialogSaveOnebox="dialogSaveOnebox" @closeSaveOnebox="closeSaveOnebox" :tokenmessage_savebox="tokenmessage_savebox"></SaveOnebox>
      </v-dialog>
</template>

<script>
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import SaveOnebox from '@/components/chat/dialog/saveonebox/SaveoneboxDialog'
import { sync } from 'vuex-pathify'
import {Momenttime, Decode} from '@/services'

export default {
  props: {dialogshowimage: false, DetailImage: {}},
  data: () => ({
    token: '',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: '',
    dialogSaveOnebox: false,
    tokenmessage_savebox: ''
  }),
  computed: {
    ...sync('*')
  },
  watch: {

  },

  // item.message, item.file_name, item.nickname, item.path_pic, dateMoment(item.timestamp),timeMoment(item.timestamp), item.tokenmessage, item.type)
  methods: {
    openPictureProfile (picture, type) {
      this.pathpicture = picture
      this.typepathpicture = type
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    loadpic(filenameSend) {
      this.axios.get(this.DetailImage.path, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    sendonebox (tokenmessage) {
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = value
    },
    closeDialogShowImage () {
      this.$emit('closeDialogShowImage', false)
    },
    date (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    }
    // this.dateSend = Momenttime.momentdatethai(timestamp)
    //   // this.timeSend = Momenttime.momenttimethai(timestamp)
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  components: {
    ShowImageProfileDialog,
    SaveOnebox
  }
}
</script>
<style scoped>
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
/*  width: 80%;
  width: auto;
  height: 70vh;*/
  max-width: 90vw !important;
  max-height: 70vh !important;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
  text-transform: none;
}
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/ShowImageDialog.vue